import { Link } from 'component_library/1_Atoms'
import { LinkProps } from 'component_library/1_Atoms/Link'
import { RudderEvent } from 'constants/rudderEvents'
import logEvent from 'utils/logEvent'

interface PhoneNumberLinkProps extends LinkProps {
  phoneNumberCTA: string
}

const PhoneNumberLink: React.FC<PhoneNumberLinkProps> = ({
  children,
  href,
  phoneNumberCTA,
  className,
}) => {
  const handleEventLog = () => {
    logEvent(RudderEvent.PHONE_NUMBER_CLICKED, {
      phone_number: phoneNumberCTA,
    })
  }

  return (
    <Link href={href} onClick={handleEventLog} className={className}>
      {children}
    </Link>
  )
}

export default PhoneNumberLink
